import './App.css';
import { UrlUtils } from './utils/url-utils';

function App() {
  let route
  const baseParams = {
    api: UrlUtils.getParam("app") || "CLOUD",
    env: UrlUtils.getParam("env") || "HOMOLOGATION"
  }
  const type = UrlUtils.getParam("type");
  if(UrlUtils.getParam("route")){
    if(type.toUpperCase() == "CATALOG"){
      route = `public/catalogs/${UrlUtils.getParam("route")}`
    }
  }
  const url = UrlUtils.getUrl(baseParams, route)
  UrlUtils.redirect(url)  
  return (
    <>
    </>
  );

}

export default App;
